var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ControlWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var DividerWidget = (function (_super) {
    __extends(DividerWidget, _super);
    function DividerWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DividerWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return DividerWidget;
}(ControlWidget));
export { DividerWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/divider.widget.ts.pre-build-optimizer.js